import { createStore } from 'vuex';

const store = createStore({
    state: {
        productId: 0,
        keyword: '',
        inputting: false,
        buildBrand: '',
        buildModel: '',
        systemVersion: '',
        softVersion: '',
        softBuild: '',
        imei: '',
        guid: '',
        buildID: '',
        channel: '',
        root: '',
        score: '',
        uninstall: '',
        qq: '',
    },
    getters: {
        getProductId(state) {
            if (state.productId === 0) {
                const value = sessionStorage.getItem('productId');
                if (value) {
                    state.productId = value;
                }
            }
            return state.productId;
        },
        getKeyword(state) {
            return state.keyword;
        },
        isInputting(state) {
            return state.inputting;
        },
        getBuildBrand(state) {
            if (state.buildBrand === '') {
                const value = sessionStorage.getItem('buildBrand');
                if (value) {
                    state.buildBrand = value;
                }
            }
            return state.buildBrand;
        },
        getBuildModel(state) {
            if (state.buildModel === '') {
                const value = sessionStorage.getItem('buildModel');
                if (value) {
                    state.buildModel = value;
                }
            }
            return state.buildModel;
        },
        getSystemVersion(state) {
            if (state.systemVersion === '') {
                const value = sessionStorage.getItem('systemVersion');
                if (value) {
                    state.systemVersion = value;
                }
            }
            return state.systemVersion;
        },
        getSoftVersion(state) {
            if (state.softVersion === '') {
                const value = sessionStorage.getItem('softVersion');
                if (value) {
                    state.softVersion = value;
                }
            }
            return state.softVersion;
        },
        getSoftBuild(state) {
            if (state.softBuild === '') {
                const value = sessionStorage.getItem('softBuild');
                if (value) {
                    state.softBuild = value;
                }
            }
            return state.softBuild;
        },
        getImei(state) {
            if (state.imei === '') {
                const value = sessionStorage.getItem('imei');
                if (value) {
                    state.imei = value;
                }
            }
            return state.imei;
        },
        getGuid(state) {
            if (state.guid === '') {
                const value = sessionStorage.getItem('guid');
                if (value) {
                    state.guid = value;
                }
            }
            return state.guid;
        },
        getBuildID(state) {
            if (state.buildID === '') {
                const value = sessionStorage.getItem('buildID');
                if (value) {
                    state.buildID = value;
                }
            }
            return state.buildID;
        },
        getChannel(state) {
            if (state.channel === '') {
                const value = sessionStorage.getItem('channel');
                if (value) {
                    state.channel = value;
                }
            }
            return state.channel;
        },
        getRoot(state) {
            if (state.root === '') {
                const value = sessionStorage.getItem('root');
                if (value) {
                    state.root = value;
                }
            }
            return state.root;
        },
        getScore(state) {
            if (state.score === '') {
                const value = sessionStorage.getItem('score');
                if (value) {
                    state.score = value;
                }
            }
            return state.score;
        },
        getUninstall(state) {
            if (state.uninstall === '') {
                const value = sessionStorage.getItem('uninstall');
                if (value) {
                    state.uninstall = value;
                }
            }
            return state.uninstall;
        },
        getQq(state) {
            if (state.qq === '') {
                const value = sessionStorage.getItem('qq');
                if (value) {
                    state.qq = value;
                }
            }
            return state.qq;
        },
    },
    mutations: {
        setProductId(state, productId) {
            state.productId = productId;
            sessionStorage.setItem('productId', productId);
        },
        setKeyword(state, keyword) {
            state.keyword = keyword;
        },
        setInputting(state, inputting) {
            state.inputting = inputting;
        },
        setBuildBrand(state, buildBrand) {
            state.buildBrand = buildBrand;
            sessionStorage.setItem('buildBrand', buildBrand);
        },
        setBuildModel(state, buildModel) {
            state.buildModel = buildModel;
            sessionStorage.setItem('buildModel', buildModel);
        },
        setSystemVersion(state, systemVersion) {
            state.systemVersion = systemVersion;
            sessionStorage.setItem('systemVersion', systemVersion);
        },
        setSoftVersion(state, softVersion) {
            state.softVersion = softVersion;
            sessionStorage.setItem('softVersion', softVersion);
        },
        setSoftBuild(state, softBuild) {
            state.softBuild = softBuild;
            sessionStorage.setItem('softBuild', softBuild);
        },
        setImei(state, imei) {
            state.imei = imei;
            sessionStorage.setItem('imei', imei);
        },
        setGuid(state, guid) {
            state.guid = guid;
            sessionStorage.setItem('guid', guid);
        },
        setBuildID(state, buildID) {
            state.buildID = buildID;
            sessionStorage.setItem('buildID', buildID);
        },
        setChannel(state, channel) {
            state.channel = channel;
            sessionStorage.setItem('channel', channel);
        },
        setRoot(state, root) {
            state.root = root;
            sessionStorage.setItem('root', root);
        },
        setScore(state, score) {
            state.score = score;
            sessionStorage.setItem('score', score);
        },
        setUninstall(state, uninstall) {
            state.uninstall = uninstall;
            sessionStorage.setItem('uninstall', uninstall);
        },
        setQq(state, qq) {
            state.qq = qq;
            sessionStorage.setItem('qq', qq);
        },
    }
});

export default store;
